module.exports = __webpack_public_path__ + "static/media/3DPPA7.b6df6b4e.jpg";